import React from 'react';
import { Link } from 'react-router-dom';
import MarketingPageShell from './MarketingPageShell';
import './MarketingPages.css';
import './Support.css';

const Support = () => {
  return (
    <MarketingPageShell>
      <section className="marketing-hero">
        <h1>Support</h1>
        <p className="lede">Need help with ShokIQ or the portal? Start here.</p>
      </section>

      <div className="marketing-inner">
        <Link to="/" className="marketing-back">
          ← Back to home
        </Link>

        <div className="marketing-card support-marketing-card">
          <h2>Contact</h2>
          <p>
            Email us at{' '}
            <a href="mailto:support@shokiq.com" className="support-link">
              support@shokiq.com
            </a>
            .
          </p>
          <p className="support-muted">
            When reporting a bug, please include your account email, the run name/id, what you uploaded (video/CSV/FIT/GPX), and any
            screenshots.
          </p>
        </div>

        <div className="marketing-card support-marketing-card">
          <h2>Self-serve</h2>
          <p>
            For product-focused suspension guidance, read the{' '}
            <Link to="/philosophy" className="support-link">
              tuning philosophy
            </Link>{' '}
            page. After you <Link to="/login" className="support-link">sign in</Link>, open <strong>Help</strong> from the app menu for
            in-product guides and troubleshooting.
          </p>
        </div>

        <div className="marketing-card support-marketing-card">
          <h2>Billing & credits</h2>
          <p>
            For credit purchases and billing issues, include your invoice email and the time of purchase in your message to support.
          </p>
        </div>

        <div className="marketing-card support-marketing-card">
          <h2>Legal</h2>
          <p>
            Review our{' '}
            <Link to="/privacypolicy" className="support-link">
              Privacy Policy
            </Link>{' '}
            and{' '}
            <Link to="/tos" className="support-link" title="Terms of Service">
              TOS
            </Link>
            .
          </p>
        </div>
      </div>
    </MarketingPageShell>
  );
};

export default Support;
